import api from './api';

export const supplierService = {
  /**
   * Obtener todos los proveedores
   */
  async getSuppliers(params = {}) {
    try {
      console.log('📡 [supplierService] Enviando petición GET a:', '/api/suppliers');
      console.log('📋 [supplierService] Parámetros:', params);
      
      const response = await api.get('/suppliers', { params });
      
      console.log('✅ [supplierService] Respuesta recibida exitosamente');
      console.log('📦 [supplierService] Response.data:', response.data);
      console.log('🔢 [supplierService] Cantidad de proveedores:', Array.isArray(response.data?.data) ? response.data.data.length : 'No es un array');
      
      return response.data;
    } catch (error) {
      console.error('❌ [supplierService] Error al obtener proveedores:', error);
      console.error('📊 [supplierService] Error.response:', error.response);
      console.error('📋 [supplierService] Error.response?.data:', error.response?.data);
      throw error;
    }
  },
  
  /**
   * Obtener un proveedor por ID
   */
  async getSupplier(id) {
    try {
      console.log('📡 [supplierService] Enviando petición GET a:', `/api/suppliers/${id}`);
      
      const response = await api.get(`/suppliers/${id}`);
      
      console.log('✅ [supplierService] Respuesta recibida exitosamente');
      console.log('📦 [supplierService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [supplierService] Error al obtener proveedor:', error);
      console.error('📊 [supplierService] Error.response:', error.response);
      throw error;
    }
  },
  
  /**
   * Crear un nuevo proveedor
   */
  async createSupplier(supplierData) {
    try {
      console.log('📡 [supplierService] Enviando petición POST a:', '/api/suppliers');
      console.log('📋 [supplierService] Datos del proveedor:', supplierData);
      
      const response = await api.post('/suppliers', supplierData);
      
      console.log('✅ [supplierService] Proveedor creado exitosamente');
      console.log('📦 [supplierService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [supplierService] Error al crear proveedor:', error);
      console.error('📊 [supplierService] Error.response:', error.response);
      console.error('📋 [supplierService] Error.response?.data:', error.response?.data);
      throw error;
    }
  },
  
  /**
   * Actualizar un proveedor
   */
  async updateSupplier(id, supplierData) {
    try {
      console.log('📡 [supplierService] Enviando petición PUT a:', `/api/suppliers/${id}`);
      console.log('📋 [supplierService] Datos del proveedor:', supplierData);
      
      const response = await api.put(`/suppliers/${id}`, supplierData);
      
      console.log('✅ [supplierService] Proveedor actualizado exitosamente');
      console.log('📦 [supplierService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [supplierService] Error al actualizar proveedor:', error);
      console.error('📊 [supplierService] Error.response:', error.response);
      console.error('📋 [supplierService] Error.response?.data:', error.response?.data);
      throw error;
    }
  },
  
  /**
   * Eliminar un proveedor
   */
  async deleteSupplier(id) {
    try {
      console.log('📡 [supplierService] Enviando petición DELETE a:', `/api/suppliers/${id}`);
      
      const response = await api.delete(`/suppliers/${id}`);
      
      console.log('✅ [supplierService] Proveedor eliminado exitosamente');
      console.log('📦 [supplierService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [supplierService] Error al eliminar proveedor:', error);
      console.error('📊 [supplierService] Error.response:', error.response);
      throw error;
    }
  },
};






